export const isEditorialRoleHidden = (role?: string | null) => {
  const normalizedRole = role?.trim().toLowerCase();
  return normalizedRole === "coach" || normalizedRole === "substitute" || normalizedRole === "sub";
};
